import BreadcrumbWrapper from '../BreadcrumbWrapper';
import FishList from './FishList';

const Fish = () => {
  return (
    <div className="flex flex-col gap-4">
      <BreadcrumbWrapper crumbArray={[{ path: '/guests', label: 'Guests' }]} />

      <h1 className="text-2xl font-bold">Guests</h1>
      <FishList />
    </div>
  );
};

export default Fish;
